export interface DiffResult {
    path: string;
    a: any;
    b: any;
}

export class ObjectCompareUtil {

    // 🔹 PUBLIC: da proveriš da li su objekti isti
    static areEqual(a: any, b: any): boolean {
        const normA = this.normalize(a);
        const normB = this.normalize(b);
        return this.diff(normA, normB).length === 0;
    }

    // 🔹 PUBLIC: ako hoćeš da vidiš razlike (debug)
    static getDiffs(a: any, b: any): DiffResult[] {
        const normA = this.normalize(a);
        const normB = this.normalize(b);
        return this.diff(normA, normB);
    }

    // 🔥 KLJUČNO: NORMALIZACIJA
    private static normalize(obj: any): any {

        // undefined i null tretiramo isto
        if (obj === undefined || obj === null) return null;

        // array
        if (Array.isArray(obj)) {
            return obj.map(x => this.normalize(x));
        }

        // objekat
        if (typeof obj === 'object') {
            const result: any = {};
            Object.keys(obj).sort().forEach(key => {
                result[key] = this.normalize(obj[key]);
            });
            return result;
        }

        // string
        if (typeof obj === 'string') {
            const trimmed = obj.trim();
            return trimmed === '' ? null : trimmed;
        }

        // number
        if (typeof obj === 'number') {
            return Number.isFinite(obj) ? obj : null;
        }

        return obj;
    }

    // 🔹 DIFF ENGINE
    private static diff(a: any, b: any, path: string = ''): DiffResult[] {
        const diffs: DiffResult[] = [];

        if (a === b) return diffs;

        const isPrimitiveA = this.isPrimitive(a);
        const isPrimitiveB = this.isPrimitive(b);

        // primitivne vrednosti
        if (isPrimitiveA || isPrimitiveB) {
            if (a !== b) {
                diffs.push({ path, a, b });
            }
            return diffs;
        }

        // ARRAY
        if (Array.isArray(a) && Array.isArray(b)) {
            const max = Math.max(a.length, b.length);

            for (let i = 0; i < max; i++) {
                diffs.push(...this.diff(
                    a[i],
                    b[i],
                    `${path}[${i}]`
                ));
            }

            return diffs;
        }

        // OBJECT
        const keys = new Set([
            ...Object.keys(a || {}),
            ...Object.keys(b || {})
        ]);

        keys.forEach(key => {

            const valA = a?.[key] === undefined ? null : a?.[key];
            const valB = b?.[key] === undefined ? null : b?.[key];

            diffs.push(...this.diff(
                valA,
                valB,
                path ? `${path}.${key}` : key
            ));
        });

        return diffs;
    }

    private static isPrimitive(val: any): boolean {
        return val === null || typeof val !== 'object';
    }
}